import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/SysMenu/List',
    method: 'post',
    data,
  })
}

export function fetchListByEndpoint() {
  return request({
    url: '/SysMenu/ListByEndpoint',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}

export function getItem(id) {
  return request({
    url: '/SysMenu/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/SysMenu/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/SysMenu/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/SysMenu/Delete',
    method: 'delete',
    data,
  })
}
